/**
 * Small helper: surface a Formik field error only once the field is touched.
 * Shared by every builder sub-editor so error display stays consistent.
 */
import { getIn, useFormikContext } from "formik";
import type { SurveyDefinition } from "./survey.types";

export const useFieldError = (): ((path: string) => string | undefined) => {
    const { errors, touched } = useFormikContext<SurveyDefinition>();
    return (path: string): string | undefined => {
        const error = getIn(errors, path);
        const wasTouched = getIn(touched, path);
        return wasTouched && typeof error === "string" ? error : undefined;
    };
};
